// extracted by mini-css-extract-plugin
export var carrierTab = "_4m-0";
export var carrierTabActive = "_4m-1 _4m-0";
export var carrierTabInactive = "_4m-2 _4m-0";
export var carrierTabLabel = "_4m-3";
export var carrierTabLabelActive = "_4m-4 _4m-3";
export var carrierTabLabelInactive = "_4m-5 _4m-3";
export var carrierTabPercentage = "_4m-6";
export var carrierTabPercentageActive = "_4m-7 _4m-6";
export var carrierTabPercentageInactive = "_4m-8 _4m-6";
export var carrierTabWinnable = "_4m-9";
export var carrierTabWinnableActive = "_4m-a _4m-9";
export var carrierTabWinnableInactive = "_4m-b _4m-9";
export var comparisonContainer = "_4m-d";
export var missingRateButton = "_4m-n";
export var missingRateButtonActive = "_4m-o _4m-n";
export var missingRateButtonInactive = "_4m-p _4m-n";
export var missingRateButtonLabel = "_4m-q";
export var missingRateButtonLabelActive = "_4m-r _4m-q";
export var missingRateButtonLabelInactive = "_4m-s _4m-q";
export var sidebar = "_4m-c";
export var strategyButton = "_4m-e";
export var strategyButtonActive = "_4m-f _4m-e";
export var strategyButtonDescription = "_4m-k";
export var strategyButtonDescriptionActive = "_4m-l _4m-k";
export var strategyButtonDescriptionInactive = "_4m-m _4m-k";
export var strategyButtonInactive = "_4m-g _4m-e";
export var strategyButtonLabel = "_4m-h";
export var strategyButtonLabelActive = "_4m-i _4m-h";
export var strategyButtonLabelInactive = "_4m-j _4m-h";
export var unitToggleButton = "_4m-t";
export var unitToggleButtonActive = "_4m-u _4m-t";
export var unitToggleButtonInactive = "_4m-v _4m-t";
export var unitToggleButtonLabel = "_4m-w";
export var unitToggleButtonLabelActive = "_4m-x _4m-w";
export var unitToggleButtonLabelInactive = "_4m-y _4m-w";